import { useEffect, useState } from "react"

export default function CursorCustom({ active }) {
    const [pos, setPos] = useState({ x: 0, y: 0 })

    useEffect(() => {
        const move = (e) => setPos({ x: e.clientX, y: e.clientY });
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, []);

    if (!active) return null

    return <>

        <div className="cursor" style={{ top: pos.y, left: pos.x }}>
            <svg className="cursor-ring" width="120" height="120" viewBox="0 0 120 120" aria-hidden="true">
                <defs>
                    <path id="cursorCircle" d="M60,60 m-45,0 a45,45 0 1,1 90,0 a45,45 0 1,1 -90,0" />
                </defs>
                <text className="cursor-text">
                    <textPath href="#cursorCircle" startOffset="0%">
                        cliquer • cliquer • cliquer •
                    </textPath>
                </text>
            </svg>

            <img className="cursor-img" src="./img/plus.svg" alt="curseur" />
        </div>

    </>
}